import { render, staticRenderFns } from "./RenderPDF.vue?vue&type=template&id=a67c3dd0"
import script from "./RenderPDF.vue?vue&type=script&lang=js"
export * from "./RenderPDF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports